<template>
  <div class="box_end">
    <div class="flex">
      <!-- <div class="box_top">
        <div class="left"></div>
        <div class="rigth_warp">
          <div class="box1"></div>
          <div class="box2"></div>
        </div>
        <div class="box_1">
          <div class="box_content">
            <div class="box_bot">1</div>
            <div class="box_content2">2</div>
          </div>
          <div class="box_4">4</div>
        </div>
      </div>-->

      <camera_two
        v-if="valueDtaa == 1"
        :getvalue="getvalue"
        @handUuid="handUuid"
        ref="getUUidTwo"
        :cuindex="cuindex"
      />
      <camera_three
        v-if="valueDtaa == 2"
        :getvalue="getvalue"
        @handUuid="handUuid"
        ref="getUUidThrdd"
      />
      <camera_firl
        v-if="valueDtaa == 3"
        :getvalue="getvalue"
        @handUuid="handUuid"
        ref="getUUidFirl"
      />

      <camera_on v-if="valueDtaa == 4" :getvalue="getvalue" @handUuid="handUuid" ref="getUUid_One" />

      <div class="bot_let">
        <div class="suoyou_shebei">
          <el-collapse v-model="activeTab">
            <el-collapse-item name="1">
              <template slot="title">
                <div class="souyou_she">所有设备</div>
              </template>
              <div class="box_fex">
                <div
                  v-for="(item,index) in treeData"
                  :key="item.id"
                  class="count_cunt"
                  :style="{color:item.uuid == currindex ? 'rgb(32, 160, 255)':''}"
                  @click="handIndex(index,item)"
                >{{item.name}}</div>
              </div>
            </el-collapse-item>
            <el-collapse-item name="2">
              <template slot="title">
                <div class="souyou_she">云台控制</div>
              </template>
              <div class="yuntai_box">
                <!-- 操作 -->
                <div class="kongzhi_left">
                  <div class="top" @click="topHand(0)">
                    <img src="@/assets/img/shexiangtou/sahng.png" alt />
                  </div>
                  <div class="konzhiL">控制</div>
                  <div class="bottom" @click="topHand(1)">
                    <img src="@/assets/img/shexiangtou/xia.png" alt />
                  </div>
                  <div class="left_end" @click="topHand(2)">
                    <img src="@/assets/img/shexiangtou/zuo.png" alt />
                  </div>
                  <div class="rigth_end" @click="topHand(3)">
                    <img src="@/assets/img/shexiangtou/you.png" alt />
                  </div>
                </div>
                <!-- 放大缩小 -->
                <div class="big_warp">
                  <div @click="topHand(8)">
                    <img src="@/assets/img/shexiangtou/fangda.png" title="放大" alt />
                  </div>
                  <!-- <div class="serch_ward">
                        <el-slider v-model="value2"></el-slider>
                  </div>-->
                  <div @click="topHand(9)">
                    <img src="@/assets/img/shexiangtou/suoxiao.png" title="缩小" alt />
                  </div>
                </div>
              </div>
            </el-collapse-item>
            <!-- <el-collapse-item name="3">
              <template slot="title">
                <div class="souyou_she">拍照截图</div>
              </template>
             
            </el-collapse-item>
            <el-collapse-item name="4">
              <template slot="title">
                <div class="souyou_she">录像回放</div>
              </template>
              <div>与现实生活一致：与现实生活的流程、逻辑保持一致，遵循用户习惯的语言和概念；</div>
              <div>在界面中一致：所有的元素和结构需保持一致，比如：设计样式、图标和文本、元素的位置等。</div>
            </el-collapse-item>-->
          </el-collapse>
          <div class="box_jietu" @click="pathLvet('/allPhotos')">
            拍照截图
            <span class="el-icon-arrow-right"></span>
          </div>
          <div class="box_jietu"  @click="pathLvet('/replayTheater')">
            录像回放
            <span class="el-icon-arrow-right"></span>
          </div>
        </div>
      </div>
    </div>
    <div class="fley">
      <div class="fly_left">
        <div class="gao_qing">高清</div>
      </div>
      <div class="conent_warp">
        <img
          src="@/assets/img/shexiangtou/shuiyin.png"
          alt="水印"
          v-if="shInFly"
          title="水印"
          @click="shui_Camer_TMDHand(0)"
        />
        <img
          src="@/assets/img/shexiangtou/shuiyinguan.png"
          alt="水印"
          v-else
          title="无水印"
          @click="shui_Camer_TMDHand(1)"
        />
        <!-- <img
          src="@/assets/img/shexiangtou/jingxiang.png"
          alt="翻转"
          title="翻转"
          @click="Fanzhuan_camer_hand"
        /> -->
        <!-- <img
          src="@/assets/img/shexiangtou/paishe.png"
          alt="抓拍"
          title="抓拍"
          @click="Zhua_pai_camerHand"
        /> -->
        <img
          src="@/assets/img/shexiangtou/shexiang.png"
          title="录像"
          alt
          @click="luxiangHand"
          v-if="luxinag_fly"
        />
        <img
          src="@/assets/img/shexiangtou/tingzhiluxiang.png"
          title="录像"
          @click="luxiangHand"
          v-else
          alt
        />
        <!-- <img
          src="@/assets/img/shexiangtou/jiance.png"
          title="布防"
          alt
          v-if="bufangFlay"
          @click="cheFanf_hand"
        />
        <img
          src="@/assets/img/shexiangtou/jianceguan.png"
          title="撤防"
          v-else
          alt
          @click="cheFanf_hand"
        />-->
      </div>
      <div class="fly_right">
        <img src="@/assets/img/shexiangtou/yiping.png" @click="handClick(1)" alt />
        <img src="@/assets/img/shexiangtou/siping.png" @click="handClick(2)" alt />
        <img src="@/assets/img/shexiangtou/jiuping.png" @click="handClick(3)" alt />
        <img src="@/assets/img/shexiangtou/yizhuwufen.png" @click="handClick(4)" alt />
      </div>
    </div>
    {{handGetUUid}}
  </div>
</template>

<script>
import camera_on from "@/components/common/camera_on";
import camera_two from "@/components/common/camera_two";
import camera_three from "@/components/common/camera_three";
import camera_firl from "@/components/common/camera_firl";
import {
  camerXuan_zhuan,
  camer_stop,
  shui_Camer_TMD,
  Fanzhuan_camer,
  zhuaPai_smd,
  CheFanf_Came,
  luXinag_camser,
  Camers_Data,
} from "@/network/lineRequest";

export default {
  props: {
    getvalue: {
      type: String,
      default: "",
    },
  },
  components: {
    camera_on,
    camera_two,
    camera_three,
    camera_firl,
  },
  data() {
    return {
      shInFly: true,
      activeTab: "2",
      value2: 10,
      valueDtaa: 1,
      monitor_uuid: "", //摄像头的uuid
      bufangFlay: true,
      luxinag_fly: true,
      treeData: [],
      currindex: "0",
      cuindex: 0,
    };
  },
  created() {},
  mounted() {},
  computed: {
    handGetUUid() {
      this.setings_data(this.getvalue);
    },
  },
  methods: {
    // 抓拍突變
    pathLvet(path) {
      
      this.$router.push({
        path: path,
        query: { monitor_uuid: this.monitor_uuid },
      });
    },
    // 切换设备
    handIndex(index, item) {
      this.getvalue = item.uuid;
      this.currindex = item.uuid;
      this.cuindex = index;
      if (this.valueDtaa == 2) {
        //第二中情况
        this.$nextTick(() => {
          this.$refs.getUUidThrdd.currindex = item.uuid;
        });
        this.monitor_uuid = item.uuid;
      } else if (this.valueDtaa == 3) {
        this.$nextTick(() => {
          this.$refs.getUUidFirl.currindex = item.uuid;
        });
        this.monitor_uuid = item.uuid;
      } else if (this.valueDtaa == 4) {
        this.$nextTick(() => {
          this.$refs.getUUid_One.currindx = item.uuid;
          this.$refs.getUUid_One.currindexIt = index;
        });
        this.$refs.getUUid_One.Camers_DataList();
        this.monitor_uuid = item.uuid;
      }
    },
    //获取所有设备
    async setings_data(uuid) {
      const { code, data, msg } = await Camers_Data({ gateway_uuid: uuid });
      this.treeData = data;
    },
    // 获取摄像头的uuid
    handUuid(e) {
      // console.log(e);
      this.currindex = e.uuid
      this.monitor_uuid = e.uuid;
      this.bufangFlay = e.isdefence == 0 ? false : true; //判断是布防还是撤防
    },
    // 向上旋转
    async topHand(e) {
      const { code, data, msg } = await camerXuan_zhuan({
        monitor_uuid: this.monitor_uuid,
        direction: e,
      });
      console.log(msg);
      if (code) {
        setTimeout(() => {
          this.stopHand(e);
        }, 1000);
      } else {
        this.$message.error(msg);
      }
    },
    // 停止旋转（2s后停止旋转）
    async stopHand(count) {
      const { code, data, msg } = await camer_stop({
        monitor_uuid: this.monitor_uuid,
        direction: count,
      });
    },
    // 切换画面
    handClick(e) {
      this.currindex = "222222222";
      this.valueDtaa = e;
    },
    // 水印
    async shui_Camer_TMDHand(e) {
      const { code, data, msg } = await shui_Camer_TMD({
        monitor_uuid: this.monitor_uuid,
        osdflag: e,
      });
      if (code) {
        this.shInFly = !this.shInFly;
        this.$message.success(msg);
        return;
      }
      this.$message.error(msg);
    },
    //反轉
    async Fanzhuan_camer_hand() {
      const { code, data, msg } = await Fanzhuan_camer({
        monitor_uuid: this.monitor_uuid,
      });
      console.log(msg);
      if (code) {
        this.$message.success("翻转" + msg);
        return;
      }
      this.$message.error(msg);
    },
    // 抓拍
    async Zhua_pai_camerHand() {
      const { code, data, msg } = await zhuaPai_smd({
        uuid: this.monitor_uuid,
      });
      if (code) {
        this.$message.success("抓拍成功");
      } else {
        this.$message.error(msg);
      }
    },
    // 布防和撤防
    async cheFanf_hand() {
      const { code, data, msg } = await CheFanf_Came({
        monitor_uuid: this.monitor_uuid,
      });
      if (code) {
        this.bufangFlay = !this.bufangFlay;
        this.$message.success(msg);
        return;
      }
      this.$message.error(msg);
    },
    // 录像
    async luxiangHand() {
      this.luxinag_fly = !this.luxinag_fly;
      const { code, data, msg } = await luXinag_camser({
        monitor_uuid: this.monitor_uuid,
      });
      if (code) {
        this.$message.success(msg);
      } else {
        this.$message.error(msg);
      }
    },
  },
};
</script>

<style scoped lang="less">
.big_warp {
  display: flex;
  width: 100%;
  align-items: center;
  justify-content: space-between;
  padding: 0 5px;
}
.serch_ward {
  width: 200px;
  // margin-right: 10px;
}
// 操作
.kongzhi_left {
  width: 150px;
  height: 150px;
  background: #efeeee;
  border: 1px solid #efeeee;
  border-radius: 50%;
  text-align: center;
  margin: 10px auto;
  display: flex;
  position: relative;
  align-items: center;
}
.top {
  position: absolute;
  top: 10px;
  left: 64px;
}
.bottom {
  position: absolute;
  bottom: 10px;
  left: 64px;
}
.big_warp div :hover {
  cursor: pointer;
}
.left_end {
  position: absolute;
  left: 8px;
}
.rigth_end {
  position: absolute;
  right: 8px;
}
.konzhiL {
  width: 50px;
  background: #333333;
  height: 50px;
  margin: 0 auto;
  line-height: 50px;
  color: #ffffff;
  border-radius: 100%;
}
/**操作 */
.souyou_she {
  padding: 0 10px;
  color: #ffffff;
}
.fly_right img {
  margin: 0 10px;
}
.conent_warp img:hover {
  cursor: pointer;
}
.gao_qing {
  width: 54px;
  height: 22px;
  border: 1px solid #ffffff;
  color: #ffffff;
  text-align: center;
  line-height: 22px;
  border-radius: 6px;
}
.fley {
  height: 70px;
  margin: 10px 0;
  background: #324157;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0 20px;
}
.box_end {
  width: 100%;
  height: 100%;
}
.flex {
  display: flex;
  flex-direction: row;
}
.box_top {
  display: flex;
  width: 88%;
  flex-wrap: wrap;
  height: 100%;
}
.bot_let {
  width: 18%;
  border: 1px solid yellow;
  // height: 100%;
  // overflow: auto;
  height: 729px;
  overflow: auto;
}
.left {
  width: 71.59%;
  border: 1px solid black;
  height: 510px;
}

.conent_warp {
  width: 500px;
  display: flex;
  justify-content: space-around;
}

.conent_warp img {
  width: 40px;
  height: 40px;
}
.kongzhi_left img:hover {
  cursor: pointer;
}
.count_cunt {
  padding: 0 10px;
}
.count_cunt:hover {
  cursor: pointer;
}

.box_jietu {
  margin-bottom: 10px;
  height: 35px;
  background: #5cb6d9 !important;
  line-height: 35px;
  padding: 0 10px;
  color: #ffffff;
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.box_jietu:hover {
  cursor: pointer;
}
</style>
